import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { FormattedMessageWithClass } from '../../utils/FormattedMessageWithClass';
import SortIcon from '-!svg-react-loader!./assets/sort.svg?name=SortIcon';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Row, Col } from 'reactstrap';
import Badge from '../SearchFilters/badge';
import messages from './messages';
import { Button } from 'antd';

import {
  makeSelectQuotationsSort,
  makeSelectSelectedQuotationsSort,
  makeSelectQuotationsParameters,
} from 'containers/Quotations/selectors';
import { withQuotationReducer } from 'containers/Quotations/withReducer';
import {
  loadFilters,
  orderBy,
  removeAll,
  removeFilter,
  downloadQuotations,
} from 'containers/Quotations/actions';

import './styles.scss';

class QuotationsSort extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onRemoveFilter = filterName => {
    this.props.removeFilter(filterName);
  };

  onOrderChange = e => {
    this.props.orderBy(e.target.value);
  };

  handleDownloadList = () => {
    this.props.downloadQuotations();
  }

  get showFiltersBadge() {
    return !!(this.props.parameters.query.length ||
            this.props.parameters.fiscal_code.length >= 11 ||
            this.props.parameters.quotation_id.length);
  }

  render() {
    const { results, sort, selectedSort, parameters, id } = this.props;
    return (
      <div id="QuotationsSort">
        <div className="element-wrapper">
          <div className="element-actions">
            <div className="form-inline justify-content-sm-end">
              <span className="sort-label">
                <SortIcon /> <FormattedMessage {...messages.sort} />
              </span>
              <label htmlFor={id} className="mb-0 sr-only sr-only-focusable">
                {`label-${id}`}
              </label>
              <select
                value={selectedSort}
                className="form-control form-control-sm form-control-faded"
                onChange={this.onOrderChange}
                id={id}
              >
                {sort.map((item, key) => (
                  <option value={item.value} key={key}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <h1 className="element-header text-medium">
            {results}
            <span> </span>
            <FormattedMessageWithClass {...messages.title} className="d-none d-lg-inline" />
            <FormattedMessageWithClass {...messages.title_short} className="d-none d-md-inline d-lg-none" />
            <Button
              className="ml-3"
              icon="download"
              size="small"
              type="link"
              onClick={this.handleDownloadList}
            >
              <FormattedMessageWithClass {...messages.download_list} className="d-none d-xl-inline" />
              <FormattedMessageWithClass {...messages.download_list_short} className="d-none d-md-inline d-xl-none" />
            </Button>
          </h1>
          {this.showFiltersBadge && (
            <Row>
              <Col>
                <FormattedMessage {...messages.query} />
                {Object.entries(parameters).map(([parameterName, parameterValue]) =>
                  parameterValue.length > 0 ?
                    <Badge
                      label={parameterValue}
                      key={parameterName}
                      active
                      onClick={() => this.onRemoveFilter(parameterName)}
                    />
                  : null
                )}
                <div className="clear" onClick={this.props.removeAll}>
                  <FormattedMessage {...messages.remove} />
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

QuotationsSort.propTypes = {
  results: PropTypes.number.isRequired,
  parameters: PropTypes.object,
  removeFilter: PropTypes.func.isRequired,
  removeAll: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  sort: makeSelectQuotationsSort(),
  selectedSort: makeSelectSelectedQuotationsSort(),
  parameters: makeSelectQuotationsParameters(),
});

export function mapDispatchToProps(dispatch) {
  return {
    loadFilters: () => dispatch(loadFilters()),
    orderBy: value => dispatch(orderBy(value)),
    removeFilter: filterName => dispatch(removeFilter(filterName)),
    removeAll: () => dispatch(removeAll()),
    downloadQuotations: () => dispatch(downloadQuotations()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withQuotationReducer,
  withConnect,
)(QuotationsSort);
